// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import ScrollReveal from "components/ScrollReveal";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

function Actividades() {
  return (
    <MKBox component="section" className="school-values" py={{ xs: 5, md: 7 }}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={12}
          sx={{ mx: "auto" }}
          rowSpacing={{ xs: 3, md: 4 }}
          columnSpacing={{ xs: 2, sm: 3, md: 4 }}
        >
          <Grid item xs={12} md={6} lg={6} xl={3} textAlign="center">
            <ScrollReveal>
              <FilledInfoCard
                color="primary"
                icon="school"
                title="Calidad educativa"
                variant="contained"
                description="Ofrecemos una educación de calidad centrada en el desarrollo integral de nuestros estudiantes."
                sx={{ height: "300px" }}
              />
            </ScrollReveal>
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={3} textAlign="center">
            <ScrollReveal delay={90}>
              <FilledInfoCard
                color="primary"
                icon="diversity_1"
                variant="contained"
                title="Convivencia"
                description="Promovemos un ambiente de convivencia basado en el respeto mutuo y la solidaridad, donde cada miembro de nuestra comunidad se siente valorado."
              />
            </ScrollReveal>
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={3} textAlign="center">
            <ScrollReveal delay={180}>
              <FilledInfoCard
                color="primary"
                icon="groups"
                variant="contained"
                title="Niveles"
                description="Desde el Nivel Inicial hasta el Secundario, ofrecemos una educación completa que prepara a los estudiantes para el futuro."
              />
            </ScrollReveal>
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={3} textAlign="center">
            <ScrollReveal delay={270}>
              <FilledInfoCard
                color="primary"
                variant="contained"
                icon="pool"
                title="Actividades"
                description="Ofrecemos una amplia gama de actividades extracurriculares que enriquecen la experiencia educativa de nuestros estudiantes."
              />
            </ScrollReveal>
          </Grid>
          {/* <Grid item xs={12} md={6} lg={4} textAlign="center">
            <FilledInfoCard
              color="primary"
              icon="church"
              variant="contained"
              title="Ejemplo"
              description="Descripción"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4} textAlign="center">
            <FilledInfoCard
              color="primary"
              variant="contained"
              icon="auto_stories"
              title="Ejemplo 2"
              description="Descripción 2."
            />
          </Grid> */}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Actividades;
